import { t } from "../../../services/utils";
import BaseStoryViewModel from "./BaseStoryViewModel";
import PhotoView from "../components/PhotoView";
import TextView from "../components/TextView";
import FilesView from "../components/FilesView";
class PostStoryViewModel extends BaseStoryViewModel {
  constructor(story, me, viewType) {
    super(story, me, viewType);
  }
  getStoryDate = () => {
    return this.story.story.da;
  };
  addContentViewModel = (parts, handler) => {
    let meta = this.story.story;
    if (meta.no) {
      parts.push({
        type: TextView,
        props: {
          text: meta.no.trim(),
          paddingBottom: meta.photo && 20,
        },
        key: `note-${this.story.story_id}`,
      });
    }
    if (meta.photo) {
      parts.push({
        type: PhotoView,
        props: {
          photo: meta.photo,
        },
        key: `photo-${this.story.story_id}`,
      });
    }
    if (meta.files && meta.files.length > 0) {
      parts.push({
        type: FilesView,
        props: {
          files: meta.files,
        },
        key: `files-${this.story.story_id}`,
      });
    }
  };
}
export default PostStoryViewModel;
